// extracted by mini-css-extract-plugin
export default {"myFooter":"Footer_myFooter__dwZM7","footerImgs":"Footer_footerImgs__gnXdd","waveFooter":"Footer_waveFooter__uxYmD","shapeFill":"Footer_shapeFill__Qc-l8"};